type WindowWithButtonRefs = Window & {
  flashButton?: HTMLElement;
  smokeButton?: HTMLElement;
}

export type ColorScheme = "light" | "dark"

export const changeColorScheme = (colorScheme: ColorScheme) => {
  const typedWindow: WindowWithButtonRefs = window;
  if (!typedWindow.flashButton || !typedWindow.smokeButton) {
    throw new Error("flashButton and/or smokeButton are unset")
  }

  if (colorScheme === "dark") {
    typedWindow.flashButton.hidden = false;
    typedWindow.smokeButton.hidden = true;
  } else if (colorScheme === "light") {
    typedWindow.flashButton.hidden = true;
    typedWindow.smokeButton.hidden = false;
  } else {
    throw new Error(`Invalid color scheme: ${colorScheme}`);
  }

  document.documentElement.style.setProperty("color-scheme", colorScheme);
};

export const init = (flashButton: HTMLElement, smokeButton: HTMLElement) => {
  const typedWindow: WindowWithButtonRefs = window;
  typedWindow.flashButton = flashButton;
  typedWindow.smokeButton = smokeButton;

  window
    .matchMedia("(prefers-color-scheme: dark)")
    .addEventListener("change", (event) =>
      changeColorScheme(event.matches ? "dark" : "light"),
    );

  changeColorScheme(
    window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light",
  );
}